import { render, staticRenderFns } from "./VFairListSkeleton.vue?vue&type=template&id=aac26166&scoped=true&"
import script from "./VFairListSkeleton.vue?vue&type=script&lang=js&"
export * from "./VFairListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./VFairListSkeleton.vue?vue&type=style&index=0&id=aac26166&scoped=true&lang=css&"
import style1 from "./VFairListSkeleton.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac26166",
  null
  
)

export default component.exports